import { render, staticRenderFns } from "./StudentStatus.vue?vue&type=template&id=7e700cea&"
import script from "./StudentStatus.vue?vue&type=script&lang=js&"
export * from "./StudentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports